import { useQuery } from '@tanstack/react-query';

import { CerberusApi } from '@hcs/cerberus';
import {
  ZipHpiTimeSeriesQueryVariables,
  ZipRpiTimeSeriesDocument,
  ZipRpiTimeSeriesQuery,
  ZipRpiTimeSeriesQueryVariables,
} from '@hcs/types';

import {
  mapPropertyTypeToPropertyTypeEnum,
  zipRpiTSQueryToCerberusRpiTS,
} from '../utils';

const QUERY_KEY_ZIP_RPI_TIME_SERIES = 'zip-rpi-time-series';

export const useZipRpiTimeSeries = ({
  zipcode,
  fromDate,
  toDate,
  propertyType,
  enabled = true,
}: ZipHpiTimeSeriesQueryVariables & {
  propertyType?: 'singleFamily' | 'condo';
  enabled?: boolean;
}) => {
  const propertyTypeEnum = mapPropertyTypeToPropertyTypeEnum(propertyType);
  return useQuery({
    queryKey: [
      QUERY_KEY_ZIP_RPI_TIME_SERIES,
      zipcode,
      fromDate,
      toDate,
      propertyType,
    ],

    queryFn: async () => {
      const response = await CerberusApi.fetchQuery<
        ZipRpiTimeSeriesQuery,
        ZipRpiTimeSeriesQueryVariables
      >(ZipRpiTimeSeriesDocument, {
        zipcode,
        fromDate,
        toDate,
        propertyType: propertyTypeEnum,
      });
      return zipRpiTSQueryToCerberusRpiTS(response);
    },

    enabled,
  });
};
